module.exports = __webpack_public_path__ + "img/5.232125d2.png";